import React from "react";
import { GerenciaProvider } from "../Context/GerenciaContext";
import GerenciaContent from "./Gerencia/GerenciaContent";

const Gerencia = () => {
  return (
    <GerenciaProvider>
      <GerenciaContent />
    </GerenciaProvider>
  );
};

export default Gerencia;